import styled from 'styled-components';

export const ShadowContainer = styled.div<{
  loggedIn: boolean;
  setMinHeight: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: ${(props) => (props.loggedIn ? '90%' : '320px')};
  width: 320px;
  min-height: ${(props) => (props.setMinHeight ? '500px' : 'auto')};
  border-radius: 12px;
  background: ${(props) => props.theme.atlas.semantic.color.surface.default};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${(props) => props.theme.boxShadows.shadowLarge}

  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: 100%;
    width: 100%;
    margin-top: 0;
    box-shadow: none;
    border-radius: 0px;
  }
`;
